module.exports = __webpack_public_path__ + "static/media/IN.16fcb0a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/IN.svg
// module id = 2173
// module chunks = 7